import React, { ReactElement } from "react";
import WatchLaterIcon from '@material-ui/icons/WatchLater';
interface TimerIconProps {
 className?: any;
}

const ChronicIcon = (props: TimerIconProps): ReactElement => {
  const {className} = props;
  return (
    <WatchLaterIcon
      className={className}
      {...props}
      style={{
        borderRadius: "50%", // Optional: Keep it circular
        padding: "5px", // Optional: Adjust padding if needed
      }}
    />
  );
};

export default ChronicIcon;
